import { transform as olTransform } from 'ol/proj'


const getCenter = (coordinates: number[]): number[] => {
    const n = coordinates.length;
    const center = [];

    coordinates.forEach(c => {
        center[0] += c[0];
        center[1] += c[1];
    });

    center[0] = center[0] / n;
    center[1] = center[1] / n;

    return center;
}

/**
 * Assumes first and last coordinate of the coordinates polygon are equal
 * @param localCoordinates
 */
const getArea = (localCoordinates: number[][]) => {
    let left = 0;
    let right = 0;
    let area = 0;

    for (let i = 0, n = localCoordinates.length - 1; i < n; i++) {
        left = left + localCoordinates[i][0] * localCoordinates[i+1][1];
        right = right + localCoordinates[i+1][0] * localCoordinates[i][1];
    }

    area = (left - right) / 2;

    return Math.abs(area);
}

/**
 * Assumes GeometryType.POLYGON with only the outer polygon.
 * @param polygon
 */
const getLocalCoordinatesInCcwOrder = (polygon, sourceProj) => {
    const coordinates = polygon.getCoordinates()[0];
    const list = [];

    for (let i = 0, n = coordinates.length; i < n; i++) {
        list[i] = olTransform(coordinates[i], sourceProj, kuura.getProjectProj4Code())
    }

    const center = getCenter(list);
    const fullCircle = 2 * Math.PI;

    list.sort((a, b) => {
        const a1 = Math.atan2(a[0] - center[0], a[1] - center[1]) + fullCircle;
        const a2 = Math.atan2(b[0] - center[0], b[1] - center[1]) + fullCircle;
        return a2 - a1;
    });

    return list;
}

export { getCenter, getArea, getLocalCoordinatesInCcwOrder };
